import React from 'react';

import {
    Table,
    Modal
} from 'antd';

class ViewDataModal extends React.Component {

    render() {

        let title = `${this.props.selectedType == 'error' ? 'Errors' : 'Updated'} for ${this.props.selectedUUID}`

        return (
            <Modal
                title={title}
                visible={this.props.visible}
                footer={false}
                onCancel={this.props.handleCloseModal}
                bodyStyle={{padding: 0}}
                width={700}
            >
                {this.renderTable()}
            </Modal>
        )

        
    }

    renderTable = () => {

        const columns = [{
            title: 'Timestamp',
            dataIndex: 'timestamp',
            render: (timestamp) => <div style={{whiteSpace: 'nowrap'}}>{timestamp}</div>,
            width: 130
        },{
            title: 'Identifier',
            dataIndex: 'identifier',
            render: (identifier) => <div style={{whiteSpace: 'nowrap'}}>{identifier}</div>,
            width: 180
        },{
            title: 'Quantity',
            dataIndex: 'quantity',
            render: (quantity) => <div style={{whiteSpace: 'nowrap'}}>{quantity}</div>,
            width: 100
        }]

        return <Table 
            dataSource={this.props.data}
            columns={columns}
            pagination={false}
            scroll={{
                y: 600
            }}
        />
    }


}

export default ViewDataModal


// WEBPACK FOOTER //
// ./src/components/stock-integration/view-data-modal.js